import { ProfileV2, SimilarCandidateExtract } from '../../types';

function getSimilarCandidatesDataFromProfile(
  seedProfile: ProfileV2,
): SimilarCandidateExtract {
  return {
    currentJobTitle: seedProfile.currentJobTitle,
    firstName: seedProfile.firstName,
    lastName: seedProfile.lastName,
  };
}

export default getSimilarCandidatesDataFromProfile;
